// WhatsApp contact helper for PlayfieldVR
export const WHATSAPP_NUMBER = "31645441448"; // +31 6 45441448
export const WHATSAPP_DISPLAY = "+31 6 45441448";

export const buildWhatsappUrl = (message?: string) => {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};
